import { BaseModel } from '@Core';
import { CameraWithInfo } from './Camera';
import { CameraTask } from './CameraTask';
import { GeoZones } from './GeoZones';
import { CameraNotes } from './CameraNotes';
import { Solar4gCamera } from './Solar4gCamera';
import { PTZCamera } from './PTZCamera';

export interface CameraTrailAuditEvent extends BaseModel {
    CameraId: number;
    OldValues: CameraTrailAuditEntity;
    NewValues: CameraTrailAuditEntity;
    AuditEventType: CameraTrailAuditEventType;
    Key?: number;
    Notes?: string;
    EntityName: CameraTrailAuditEventEntityName;

    CameraTask?: CameraTask;
}

export type CameraTrailAuditEntity = Partial<
    CameraWithInfo | GeoZoneAuditEvent | CameraTask | CameraNotes | PTZCamera | Solar4gCamera
>;

export enum CameraTrailAuditEventEntityName {
    camera = 'Camera',
    geoZones = 'GeoZones',
    notes = 'Notes',
    cameraNotes = 'CameraNotes',
    cameraTask = 'CameraTask',
    solar4gCamera = 'Solar4gCamera',
    ptzPreset = 'PTZPresets',
}

export interface GeoZoneAuditEvent extends Omit<GeoZones, 'GeoZoneCoordinates'> {
    EffectiveFrom: Date;
    GeoZoneCoordinates: GeoZoneCoordinatesPoint;
}

export interface GeoZoneCoordinatesPoint {
    X1: number;

    Y1: number;

    X2: number;

    Y2: number;

    X3: number;

    Y3: number;

    X4: number;

    Y4: number;
}

export enum CameraTrailAuditEventType {
    CREATE,
    UPDATE,
    DELETE,
    OTHER,
    RETRIEVE,
}

export enum CameraTrailAuditOtherEventType {
    WAKE,
    REFRESH,
    VIEW,
    REFRESH_PTZ_CONFIG,
    REFRESH_PMC8266_CONFIG,
}
